export const Labels = {
  COMMON: {
    CLOSE: 'Close',
    CANCEL: 'Cancel',
    STEPS:{
        INITIATE:'Initiate',
        GENERATE:'Generate',
        REVIEW:'Review',
        APPROVED:'Approved'
    }
  },
  REPORT_SECTIONS: {
    NOTE: 'Note : This content is generated by AI. Please review it carefully.',
    TABLE_OF_CONTENTS: 'Table of Contents',
    AVERAGE_QUALITY_SCORE: 'Average Quality Score:',
    REPORT_ID: 'Report ID #',
    ADD_SUB_SECTION: 'Add as a Sub Section',
    CLIENT_NAME: 'Client Name:',
    LOCATION_NAME: 'Location Name:',
    REFERRENCES: 'References',
    COMMENT:'Comments for Report ID #',
    ENTER_COMMENT:'Enter your comments here...',
    COMMENT_CLEAR:'Clear',
    SELECT_POSTION:'Select Position',
    SELECT_TITLE:'Select Title',
    SECTION_CONTENT:'Section Content',
    COMMENT_POST:'Post',
    BUTTON: {
      ADD_SECTION: 'Add Section',
      SUBMIT_FOR_APPROVAL: 'Submit for Approval',
      SEND_FOR_REVISION: 'Send For Revision',
      APPROVE_REPORT: 'Approve',
      AGENT_REWORK: 'Send to Agents for Rework',
    },
  },
};
